import Menu from "src/components/menu/Menu";
import Footer from "src/footer/Footer";
import ISettings from "src/lib/types/Settings";

import { Lexend } from "next/font/google";
import classNames from "classnames";

const lexend = Lexend({
    weight: ["200", "400", "700"],
    display: 'swap',
    subsets: ["latin"],
    fallback: ["sans-serif"],
    variable: "--font-lexend"
});

//#region [Props]
type DefaultLayoutProps = {
	children: React.ReactNode;
	appSettings?: ISettings;
};
//#endregion

//#region [Component]
export default function DefaultLayout({ children, appSettings }: DefaultLayoutProps) {
	if (!appSettings) {
		console.error("Appsettings is null");
		return null;
	}

	return <main className={classNames(lexend.className, lexend.variable)}>

		<Menu settings={appSettings} />
		{children}
		<Footer appSettings={appSettings}/>
	</main>

}
//#endregion

//#region [Styles]

//#endregion